(function ($) {

    $('#paramCarousel').carousel({
        interval: false
    })

    $(document).ready(function () {
        same_height();

        $(".nav-main").clone().prependTo("#off-canvas");
        $(function () {
            $(document).trigger("enhance");
        });

        $('#off-canvas').offcanvas({});
    });

})(jQuery);


function same_height(){
    jQuery('.same_height').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    jQuery('.same_height_col').matchHeight({
        byRow: false,
        property: 'height',
        target: null,
        remove: false
    });

}


// WEBPACK FOOTER //
// ./assets/js/theme.js